"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.utils = exports.Network = exports.initializeApp = void 0;
var authority_manager_js_1 = require("./authority/authority-manager.js");
var api_manager_js_1 = require("./api/api-manager.js");
var event_handler_js_1 = require("./api/event-handler.js");
var index_1 = require("./utils/index");
Object.defineProperty(exports, "utils", { enumerable: true, get: function () { return index_1.publicUtils; } });
var networks_1 = __importDefault(require("./models/networks"));
exports.Network = networks_1.default;
var baseConfig = {
    network: networks_1.default.mumbai,
    provider: {
        address: "",
        key: "",
        id: ""
    }
};
var auth = (0, authority_manager_js_1.authorityManager)(baseConfig);
var api = (0, api_manager_js_1.apiManager)(baseConfig);
var mint = (0, api_manager_js_1.mintManager)(baseConfig);
var basin = null;
var initializeApp = function (initConfig) {
    if (initConfig == null) {
        throw Error("Configuration is null");
    }
    var network = initConfig.network;
    if (network == null || network.length == 0) {
        throw Error("Network must not be empty");
    }
    var basinNetwork = network;
    if (basinNetwork == null) {
        throw Error("Network is null");
    }
    var provider = initConfig.provider;
    if (provider == null) {
        throw Error("Provider is null");
    }
    var id = provider.id;
    if (id == null || id.length == 0) {
        throw ("Provider is null");
    }
    var key = provider.key;
    if (key == null || key.length == 0) {
        throw ("Provider key is null");
    }
    var address = provider.address;
    if (address == null || address.length == 0) {
        throw ("Provider address is null");
    }
    var config = {
        network: basinNetwork,
        provider: {
            id: id,
            address: address,
            key: key
        }
    };
    basin = {
        config: config,
        auth: (0, authority_manager_js_1.authorityManager)(config),
        api: (0, api_manager_js_1.apiManager)(config),
        mint: (0, api_manager_js_1.mintManager)(config),
        events: event_handler_js_1.eventHandler,
        utils: index_1.publicUtils,
    };
    return basin;
};
exports.initializeApp = initializeApp;
exports.default = basin;
